import * as Yup from 'yup';
import { useState, forwardRef } from 'react';
import { Link as RouterLink, useLocation, useNavigate } from 'react-router-dom';
import { useFormik, Form, FormikProvider } from 'formik';
// material
import {
  Stack,
  TextField,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContentText,
  DialogContent,
  Button,
  Slide
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useAuth } from '../../customContextProviders/AuthContext';
import { ValidateLoginOTP } from '../../../network/User';
import { parseValidationErrorMessage } from '../../../utils/Utilities';
import { SnackBarAlert } from '../../HelperComponents';

/* eslint-disable */
const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function ValidateOTPForm() {
  const navigate = useNavigate();
  const location = useLocation();

  const [showPassword, setShowPassword] = useState(false);
  const { authenticateSession } = useAuth();

  const [errorData, setErrorData] = useState({
    visible: false,
    message: '',
    title: ''
  });

  const [openAlertDialog, setOpenAlertDialog] = useState(false);
  const [alertDialogMetas, setAlertDialogMetas] = useState({
    message: '',
    title: '',
    btnLabel: ''
  });

  const [isSnackBarAlertOpen, setIsSnackBarAlertOpen] = useState(false);
  const [snackBarMetas, setSnackBarMetas] = useState({
    title: '',
    message: '',
    severity: 'info',
    handleClose: null
  });

  const OTPSchema = Yup.object().shape({
    otp: Yup.string().required('OTP is required')
  });

  const formik = useFormik({
    initialValues: {
      otp: ''
    },
    validationSchema: OTPSchema,
    onSubmit: () => {
      doLogin(location?.state?.userEmail, formik.values.otp);
    }
  });

  const handleAlertDialogClose = () => {
    setErrorData({ ...errorData, visible: false, message: '' });
  };

  const { errors, touched, values, isSubmitting, handleSubmit, getFieldProps } = formik;

  const handleShowPassword = () => {
    setShowPassword((show) => !show);
  };

  function doLogin(email, otp) {
    ValidateLoginOTP(email, otp)
      .then((res) => {
        formik.setSubmitting(false);

        authenticateSession(res?.data);
        navigate('/dashboard/soundboxT', { replace: true });
      })
      .catch((error) => {
        formik.setSubmitting(false);
        setSnackBarMetas((prevState) => ({
          ...prevState,
          title: parseValidationErrorMessage(error),
          severity: 'error'
        }));
        setIsSnackBarAlertOpen(true);
      });
  }

  return (
    <div>
      <FormikProvider value={formik}>
        <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
          <Stack spacing={3}>
            <TextField
              fullWidth
              type="tel"
              autoComplete="otp"
              label="Enter OTP "
              {...getFieldProps('otp')}
              error={Boolean(touched.otp && errors.otp)}
              helperText={touched.otp && errors.otp}
            />
          </Stack>

          {/* <Stack direction="row" alignItems="center" justifyContent="flex-end" sx={{ my: 3 }}>
            <FormControlLabel
            control={<Checkbox {...getFieldProps('remember')} checked={values.remember} />}
            label="Remember me"
          />

            <Link component={RouterLink} variant="subtitle2" to="/forgetpassword">
              Forgot password?
            </Link>
          </Stack> */}

          <LoadingButton
            fullWidth
            size="large"
            type="submit"
            variant="contained"
            loading={isSubmitting}
            sx={{ mt: 3 }}
          >
            Submit
          </LoadingButton>
        </Form>
      </FormikProvider>

      <Dialog
        open={errorData?.visible}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => handleAlertDialogClose()}
        aria-describedby="iot_res_alert-dialog-slide-description"
      >
        <DialogTitle>{errorData?.title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="aiot_res_alert-dialog-slide-description">
            {errorData?.message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleAlertDialogClose()}>OK</Button>
        </DialogActions>
      </Dialog>

      <SnackBarAlert
        open={isSnackBarAlertOpen}
        title={snackBarMetas?.title}
        message={snackBarMetas?.message}
        severity={snackBarMetas?.severity}
        handleClose={() => setIsSnackBarAlertOpen(false)}
      />
    </div>
  );
}
